import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 60 60\" id=\"icon-mail\">\r\n<style type=\"text/css\">\r\n\t#icon-mail .st0{fill:#9CCEC1;}\r\n</style>\r\n<path class=\"st0\" d=\"M52,18.3v-5.7L29.5,26.7L7,12.7v5.7l22.5,13.9L52,18.3z M52,7c1.5,0,2.8,0.6,3.9,1.7s1.6,2.5,1.6,3.9v33.7\r\n\tc0,1.5-0.5,2.8-1.6,3.9C54.7,51.4,53.5,52,52,52H7c-1.5,0-2.8-0.6-3.9-1.7c-1.1-1.1-1.6-2.5-1.6-3.9V12.7c0-1.5,0.5-2.8,1.6-3.9\r\n\tS5.5,7,7,7L52,7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mail.svg
// module id = CFfD
// module chunks = 87